const defaultKeyCommands = [
  'bold',
  'italic',
  'underline',
  'backspace',
  'backspace-word',
  'backspace-to-start-of-line',
  'delete',
  'delete-word',
  'delete-to-end-of-block',
];

export const getKeyCommands = ({ disabledKeyCommands = [] } = {}) => defaultKeyCommands.filter(
  command => !disabledKeyCommands.includes(command)
);

export default defaultKeyCommands;
